import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useDebounce, useToast } from "../../../../shared/hooks";
import { FinancialService } from "../../../../shared/services/api/financial/FinancialService";
import { ToastContent } from "../../../../shared/components";
import { GenericToolbar } from "../GenericToolbar";
import { LoadingComp } from "../../../../shared/components/loading/Loading";
import { TableInstallmentCreditCard } from "../TableInstallmentCreditCard";

export const CreditCardTab = () => {
	const { debounce } = useDebounce();
	const toastHandler = useToast();

	const [textSearch, setTextSearch] = useState("");
	const [dataIni, setDataIni] = useState("");
	const [dataFim, setDataFim] = useState("");
	const [status, setStatus] = useState("");
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [refreshTrigger, setRefreshTrigger] = useState(0);

	const [comissionData, setComissionData] = useState<any[]>([]);
	const [isLoading, setIsLoading] = useState(false);

	const handleFetchData = (currentPage: number, limit: number, search: string, ini: string, fim: string, stat: string) => {
		setIsLoading(true);
		debounce(() => {
			FinancialService.getInstallmentCreditCard(currentPage + 1, limit, search, stat, ini, fim, "credit_card")
				.then((response) => {
					if (response instanceof Error) {
						toastHandler.present({
							type: "error",
							position: "top-right",
							messageOrContent: <ToastContent title="Erro" content="Erro ao buscar valores" />,
						});
					} else {
						setComissionData(response.data);
						setTotalCount(response.totalCount ?? 0);
					}
				})
				.finally(() => setIsLoading(false));
		});
	};

	useEffect(() => {
		const defaultDataIni = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split("T")[0];
		const defaultDataFim = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().split("T")[0];

		setTextSearch("");
		setDataIni(defaultDataIni);
		setDataFim(defaultDataFim);
		setStatus("");

		handleFetchData(page, rowsPerPage, "", defaultDataIni, defaultDataFim, "");
	}, [refreshTrigger, page, rowsPerPage]);
	const handleChangePage = (newPage: number) => setPage(newPage);

	const handleChangeRowsPerPage = (newRowsPerPage: number) => {
		setRowsPerPage(newRowsPerPage);
		setPage(0);
	};

	const handleSearch = () => {
		setPage(0);
		handleFetchData(0, rowsPerPage, textSearch, dataIni, dataFim, status);
	};

	const handleRefresh = () => setRefreshTrigger((prev) => prev + 1);

	return (
		<Box>
			<GenericToolbar
				showInputSearch
				showDateRange
				showStatusSelect={false}
				textSearch={textSearch}
				onChangeTextSearch={(value: string) => setTextSearch(value)}
				onClearTextSearch={() => setTextSearch("")}
				onChangeDateStart={(date: string) => setDataIni(date)}
				onChangeDateEnd={(date: string) => setDataFim(date)}
				onChangeStatus={(statusValue: string) => setStatus(statusValue)}
				onClickRefresh={handleSearch}
			/>

			<LoadingComp isopen={isLoading} />

			<TableInstallmentCreditCard
				rows={comissionData}
				page={page}
				rowsPerPage={rowsPerPage}
				totalCount={totalCount}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
				dataIni={dataIni}
				dataFim={dataFim}
				onRefresh={handleRefresh}
			/>
		</Box>
	);
};
